export const getToken = async () => {
  if (typeof window !== "undefined") {
    const Cookies = (await import("js-cookie")).default;
    return Cookies.get("access_token") || null;
  } else {
    const { headers } = await import("next/headers");
    const requestHeaders = await headers();
    const cookieHeader = requestHeaders.get("cookie") || "";

    const match = cookieHeader.match(/access_token=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
};
